import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import FormDialog from '../../../components/ui/FormDialog';
import { notify, getErrorMessage } from '../../../components/feedback/notify';

const paraTextoBr = (valor) => (valor === null || valor === undefined ? '' : String(valor).replace(".", ","));

export default function EditarPlano(props) {
    const token = localStorage.getItem('token');

    const [nomePlano, setNomePlano] = useState('');
    const [valorAntigo, setValorAntigo] = useState('');
    const [valorNovo, setValorNovo] = useState('');
    const [descricao, setDescricao] = useState('');
    const [qtdNfseMensalUsuario, setQtdNfseMensalUsuario] = useState('');
    const [qtdNfseMensalClarea, setQtdNfseMensalClarea] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!props.idPlano) return;
        const getPlanoById = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/getPlanoById/${props.idPlano}`, {
                    headers: {
                        Authorization: token
                    }
                });

                setNomePlano(response?.data?.plano?.nome);
                setValorAntigo(paraTextoBr(response?.data?.plano?.valorAntigoMensal));
                setValorNovo(paraTextoBr(response?.data?.plano?.valorNovoMensal));
                setDescricao(response?.data?.plano?.descricao);
                setQtdNfseMensalUsuario(response?.data?.plano?.qtdNfseMensalUsuario);
                setQtdNfseMensalClarea(response?.data?.plano?.qtdNfseMensalClarea);
            } catch (error) {
                console.error("Erro ao buscar plano:", error);
                notify.error("Não foi possível carregar os dados do plano.");
            }
        }
        getPlanoById();
    }, [props.idPlano, token]);


    const handleClose = () => {
        props.setEditarPlano(false);
    };

    const handleSubmit = async () => {
        let vlAntigo = Number(String(valorAntigo || '').replace(".", "").replace(",", "."));
        let vlNovo = Number(String(valorNovo || '').replace(".", "").replace(",", "."));

        if (!nomePlano || Number.isNaN(vlAntigo) || Number.isNaN(vlNovo) || vlAntigo <= 0 || vlNovo < 0) {
            notify.warning("Informe o nome do plano e valores válidos.");
            return;
        }

        let x = vlAntigo - vlNovo;
        let percentual = (x / vlAntigo) * 100;

        try {
            setLoading(true);
            await axios.put(`${process.env.REACT_APP_API_URL}/atualizarPlano/${props.idPlano}`, {
                nome: nomePlano,
                valorAntigoMensal: vlAntigo,
                valorNovoMensal: vlNovo,
                percentual,
                descricao,
                qtdNfseMensalUsuario,
                qtdNfseMensalClarea
            }, {
                headers: {
                    Authorization: token
                }
            });
            notify.success("Plano atualizado com sucesso.");
            handleClose();
        } catch (error) {
            console.error("Erro ao atualizar plano:", error);
            notify.error(getErrorMessage(error, "Não foi possível atualizar o plano."));
        } finally {
            setLoading(false);
        }
    };

    const reais = { input: { startAdornment: <InputAdornment position="start">R$</InputAdornment> } };

    return (
        <FormDialog
            open={props.editarPlano}
            onClose={handleClose}
            onSubmit={handleSubmit}
            title="Editar plano"
            description="O percentual de desconto é calculado automaticamente a partir dos valores antigo e novo."
            submitLabel="Salvar alterações"
            loading={loading}
        >
            <TextField
                autoFocus
                required
                label="Nome do plano"
                fullWidth
                value={nomePlano || ''}
                onChange={(e) => setNomePlano(e.target.value)}
                size="small"
            />
            <TextField
                label="Descrição"
                placeholder="Descrição exibida ao cliente"
                fullWidth
                multiline
                minRows={2}
                value={descricao || ''}
                onChange={(e) => setDescricao(e.target.value)}
                size="small"
            />
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                <TextField
                    required
                    label="Valor antigo mensal"
                    placeholder="0,00"
                    fullWidth
                    value={valorAntigo || ''}
                    onChange={(e) => setValorAntigo(e.target.value)}
                    size="small"
                    slotProps={reais}
                />
                <TextField
                    required
                    label="Valor novo mensal"
                    placeholder="0,00"
                    fullWidth
                    value={valorNovo || ''}
                    onChange={(e) => setValorNovo(e.target.value)}
                    size="small"
                    slotProps={reais}
                />
                <TextField
                    required
                    label="NFS-e por mês (cliente)"
                    fullWidth
                    value={qtdNfseMensalUsuario ?? ''}
                    onChange={(e) => setQtdNfseMensalUsuario(e.target.value)}
                    size="small"
                />
                <TextField
                    required
                    label="NFS-e por mês (Contblack)"
                    fullWidth
                    value={qtdNfseMensalClarea ?? ''}
                    onChange={(e) => setQtdNfseMensalClarea(e.target.value)}
                    size="small"
                />
            </Box>
        </FormDialog>
    );
}
